import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { convertPercentToNumber } from '../../utils/utils';
import TouchpointIcon from './touchpoint-icon';

const useStyles = makeStyles(theme => ({
  root: {
    overflow: 'hidden'
  },
  margin: {
    margin: theme.spacing(1),
  },
  left: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
  },
  right: {
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
  },
  rightIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
  }
  
}));

const ProgressBar = ({ position, value, size, type, theme }) => {
    const classes = useStyles();
    const inactiveLeftBar = 100 - convertPercentToNumber(value);

    return (
        <Box
            bgcolor={theme ? "#22384f": "#EAECF0"}
            display="flex"
            width="100%" 
            height={size} 
            className={clsx(classes.root, position === 'left' ? classes.left: classes.right)}
        >
            { position === 'left' && <Box width={`${inactiveLeftBar}%`}></Box> }
            <Box
                bgcolor={theme ? "#384c60": "#D8DCE5"}
                width={value}
                className={clsx(classes.root, position === 'left' ? classes.left: classes.rightIcon)}
            >
                <TouchpointIcon type={type} size={size} theme={theme}/>
            </Box>
        </Box>
    );
}

export default ProgressBar;